<template>
  <AutoComplete
    ref="inputField"
    :modelValue="tags"
    :multiple="true"
    :suggestions="options"
    @complete="onSearch($event)"
    @item-select="onSelect($event)"
    @item-unselect="onUnselect($event)"
    @keyup.enter="onCreate()"
    field="name"
  />
</template>

<script>
import slugify from 'slugify';
import { TagApi } from '../services/api';

export default {
  name: 'TagAutocomplete',
  props: {
    modelValue: Array,
    typeId: Number,
    isVetCustomer: Boolean,
  },
  data() {
    return {
      options: [],
    };
  },
  computed: {
    tags() {
      return (this.modelValue || []).map((tag) => tag.tag);
    },
  },
  methods: {
    isExistentTag(name) {
      const opts = { lower: true };
      return (this.modelValue || []).some(
        (tag) => slugify(tag.tag.name, opts) === slugify(name, opts)
      );
    },
    async onSearch(event) {
      const query = {
        orderField: 'name',
        order: 'asc',
        name: event.query || undefined,
        typeId: this.typeId,
      };
      const fetchResponse = await TagApi.fetch(query, { isVetCustomer: this.isVetCustomer });
      const options = fetchResponse.results.filter(
        (tag) => !this.isExistentTag(tag.name)
      );
      this.options = options;
    },
    async onCreate() {
      if (!this.$refs.inputField.inputTextValue) {
        return;
      }
      const name = this.$refs.inputField.inputTextValue;
      if (!this.isExistentTag(name)) {
        const data = { name, typeId: this.typeId };
        const tag = await TagApi.create(data, { isVetCustomer: this.isVetCustomer });
        this.$emit('update:modelValue', [
          ...this.modelValue,
          { tagId: tag.id, tag },
        ]);
      }
      this.$refs.inputField.inputTextValue = '';
      const input = this.$refs.inputField.$el.querySelector('input');
      if (input) input.value = '';
    },
    onSelect(event) {
      const tag = { tagId: event.value.id, tag: event.value };
      this.$emit('update:modelValue', [...this.modelValue, tag]);
    },
    onUnselect(event) {
      const values = this.modelValue.filter(
        (tag) => tag.tagId !== event.value.id
      );
      this.$emit('update:modelValue', values);
    },
  },
};
</script>

<style>
</style>
